// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "InlineNotification-module--bx--text-truncate--end--3tUN9";
export var bxTextTruncateFront = "InlineNotification-module--bx--text-truncate--front--3VagD";
export var darkMode = "InlineNotification-module--darkMode--1JNAj";
export var notification = "InlineNotification-module--notification--2zT4F";